import Axios from "../api/axios";
import config from "../../config";

const getLetterDetails = (letter) => {
  return Axios.get(`${config.BASE_URL}letters?filters[Slug][$eq]=${letter}&populate=*`);
};

export default getLetterDetails;
